import { HarddiskRemoveIcon } from './HarddiskRemoveIcon';

/**
 * author: Michael Richins
 * id 07449A81-73AE-484C-8739-E008C38502F1
 * name harddisk-remove
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/harddisk-remove.svg
 * tags
 */
export const HddRemoveIcon = HarddiskRemoveIcon;
export default HddRemoveIcon